import { render, staticRenderFns } from "./TooltipOver.vue?vue&type=template&id=2fbd8055&scoped=true"
import script from "./TooltipOver.vue?vue&type=script&lang=js"
export * from "./TooltipOver.vue?vue&type=script&lang=js"
import style0 from "./TooltipOver.vue?vue&type=style&index=0&id=2fbd8055&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd8055",
  null
  
)

export default component.exports